
import React from "react";
import { Photo } from "@/types/photos";
import PhotoCard from "@/components/PhotoCard";
import FadeIn from "@/components/FadeIn";

interface PhotoGridProps {
  photos: Photo[];
  isGridView: boolean;
  onDownload: (id: string) => void;
}

const PhotoGrid: React.FC<PhotoGridProps> = ({ photos, isGridView, onDownload }) => {
  if (photos.length === 0) {
    return (
      <div className="text-center py-12 border rounded-lg">
        <h3 className="text-lg font-medium">No photos found</h3>
        <p className="text-muted-foreground">
          Try adjusting your search or filter options
        </p>
      </div>
    );
  }

  return (
    <div className={`grid gap-6 ${
      isGridView 
        ? "grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4" 
        : "grid-cols-1"
    }`}>
      {photos.map((photo, index) => (
        <FadeIn key={photo.id} delay={index * 50}>
          <PhotoCard
            {...photo}
            onDownload={onDownload}
            className={!isGridView ? "flex flex-row h-40" : ""}
          />
        </FadeIn>
      ))}
    </div>
  );
};

export default PhotoGrid;
